import React, { useEffect, useState, useRef } from 'react';
// import AboutImg from '../../assets/about1.png';
import { AboutPageImageBg } from '../../data/photos';
import {ImageFadeReveal, FadeIn } from "../../utils/AboutUsFadeEffects";

export default function AboutHeroCard() {
  return (
    <section className="flex flex-col items-center justify-center w-full min-h-[170px] md:min-h-[300px] pt-12 pb-8 bg-gradient-to-r from-sky-100 via-white to-sky-50">
      <FadeIn direction="bottom">
        <div className="relative w-full flex items-center justify-center py-16">
          <ImageFadeReveal
            src={AboutPageImageBg}
            alt="Ambulance service team working"
            className="object-contain w-full max-w-xs sm:max-w-sm md:max-w-md rounded-xl shadow-md"
            style={{ filter: ' brightness(0.98) saturate(1.1)' }}
          />
        </div>
      </FadeIn>
    </section>
  );
}
